import React, { useEffect, useRef, useState } from "react";
import AppConfig from './AppConfig.json'
import axios from "axios";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import * as actions from './actions'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ErrorMessage from "./ErrorMessage";
import PinInput from "react-pin-input";

function DataField({ name, value, showNav, nameStyle, valueStyle, iconColor, onClick }) {
    return <div className="data-field" onClick={onClick}>
        <div className="data-name" style={nameStyle}>{name}</div>
        <div className="data-value" style={valueStyle}>{value}</div>
        {showNav && <div className="icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.64645 13.3536C5.45118 13.1583 5.45118 12.8417 5.64645 12.6464L10.2929 8L5.64645 3.35355C5.45118 3.15829 5.45118 2.84171 5.64645 2.64645C5.84171 2.45118 6.15829 2.45118 6.35355 2.64645L11.3536 7.64645C11.4473 7.74022 11.5 7.86739 11.5 8C11.5 8.13261 11.4473 8.25979 11.3536 8.35355L6.35355 13.3536C6.15829 13.5488 5.84171 13.5488 5.64645 13.3536Z" fill={iconColor ? iconColor : 'white'} />
            </svg>
        </div>}
    </div>
}

function MemberEditMobile(props) {
    let { app, onUpdate } = props
    const { currentUserProfile } = app
    const history = useHistory()
    const [mobileNumber, setMobileNumber] = useState("")
    const [mobileCountryCode, setMobileCountryCode] = useState("66")
    const [errorMessage, setErrorMessage] = useState(null)
    const [verifyOTP, setVerifyOTP] = useState(false)
    const [otpRequestID, setOtpRequestID] = useState(true)
    let [isMismatch, setIsMismatch] = useState(false)
    let pinInput = useRef()

    useEffect(() => {
        setMobileCountryCode(currentUserProfile.mobileCountryCode)
        setMobileNumber(currentUserProfile.mobileNumber)
        const interval = setInterval(() => {
            setVerifyOTP(verifyOTP => verifyOTP > 0 ? verifyOTP - 1 : verifyOTP)
        }, 1000);
        return () => clearInterval(interval);
    }, [])


    const formValidate = () => {
        const re = /0[0-9]{9}/;
        console.log(mobileNumber, re.test(mobileNumber))

        return mobileNumber && re.test(mobileNumber)
    }

    const validateOTP = async (pin) => {
        console.log({ code: pin, otpRequestID })
        try {
            let result = await axios.post(`${AppConfig.endpoint}/member/otp/verify`, { code: pin, otpRequestID }, {
                headers: {
                    "x-access-token": app.accessToken,
                    "x-api-key": AppConfig.api_key
                }
            })

            console.log(result)

            if (!result.error) {
                if (result.data && result.data.isVerified) {
                    sendUpdate()
                }
                else {
                    setIsMismatch(true)
                }
            }

        }
        catch (err) {
            // history.push("/member/error")
            // setIsMismatch(true)
        }
    }


    const requestOtp = async () => {
        try {
            let result = await axios.post(`${AppConfig.endpoint}/member/otp/request`, {
                type: "mobile", on: {
                    country: mobileCountryCode,
                    value: mobileNumber
                }
            }, {
                headers: {
                    "x-access-token": props.app.accessToken,
                    "x-api-key": AppConfig.api_key
                }
            })

            console.log(result)

            if (!result.error) {
                setOtpRequestID(result.data.requestID)
                setVerifyOTP(299) // Timeout 5 min.( 300 sec.)
            }

        }
        catch (err) {
            // history.push("/member/error")
            // setIsMismatch(true)
        }
    }

    const sendUpdate = async () => {

        let body = { mobile: mobileNumber, mobileCountry: mobileCountryCode }

        let result = await axios.post(`${AppConfig.endpoint}/member/update/mobile`, body, {
            headers: {
                "x-access-token": app.accessToken,
                "x-api-key": AppConfig.api_key
            }
        })

        if (result.data.success) {
            onUpdate && onUpdate()
            history.push("/member/profile")
        }
        else {
            setErrorMessage(result.data)
        }
    }

    return <div className="edit-screen pin-auth-screen">
        {errorMessage && <ErrorMessage title="Error" message={errorMessage} />}
        {verifyOTP === false && <>
            <div class="section-header">Mobile</div>
            <div className="edit-form">

                <PhoneInput
                    country={mobileCountryCode}
                    disableCountryCode={true}
                    value={mobileNumber}
                    autoFormat={false}
                    renderFlagAsDial={true}
                    specialLabel={<label className="label">Mobile Number</label>}
                    onChange={(mobileNumber, country) => { setMobileNumber(mobileNumber); setMobileCountryCode(country.dialCode) }}
                />
                {/* <div className="field">
                <label className="label">Mobile Number</label>
                <div className="control">
                    <input className="input" type="text" value={email} onChange={(e) => setEmail(e.target.value)} />
                </div>
            </div> */}
            </div>

            <div className="screen-footer">
                <button className="button is-fullwidth is-save" disabled={!formValidate()} onClick={() => requestOtp()}>Continue</button>
            </div>
        </>}
        {verifyOTP !== false && <>
            <div style={{ marginBottom: 20 }}>Enter OTP</div>
            <div className="hint" style={{ background: 'none', color: '#888' }}>Enter OTP sent to your mobile number *******{mobileNumber.slice(mobileNumber.length - 4)}</div>

            <PinInput
                ref={pinInput}
                length={6}
                initialValue=""
                secret={false}
                onChange={(value, index) => { }}
                type="numeric"
                inputMode="number"
                style={{ borderRadius: 8 }}
                inputStyle={{
                    height: 48,
                    width: 40,
                    borderRadius: 8,
                    background: '#252525',
                    border: 0,
                    margin: 4,
                    fontSize: 25,
                    color: '#FFFFFF'

                }}
                inputFocusStyle={{ background: '#383838', border: 0 }}
                onComplete={(value, index) => {
                    validateOTP(value)
                    pinInput.current.clear()
                }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
            />

            {verifyOTP > 0 && <div className="hint" style={{ background: 'none', color: '#888' }}>Resend OTP code if it doesn’t arrive in {Math.floor(verifyOTP / 60)}:{verifyOTP % 60 > 9 ? verifyOTP % 60 : `0${verifyOTP % 60}`}</div>}

            {isMismatch && <div className="help has-text-danger">Incorrect OTP. Please try again.</div>}
            {verifyOTP <= 0 && <div className="screen-footer">
                <button className="button is-fullwidth is-save" onClick={() => requestOtp()}>Resend OTP</button>
            </div>}

        </>}
    </div>
}

export default withRouter(connect((state) => state, actions)(MemberEditMobile))